// extracted by mini-css-extract-plugin
export default {"main":"Paginacao_main__5pu3t","registros":"Paginacao_registros__SWWfx","btnPage":"Paginacao_btnPage__w7f6q"};